module.exports = __webpack_public_path__ + "static/media/KIDS.66ce9e24.webp";